// TWE mobile nav drill-down — document-level delegated handler so it keeps
// working even if the header/drawer markup gets re-rendered (theme editor
// live preview, sticky-header clones, etc.), unlike an inline <script>
// inside the snippet itself, which only binds once at initial parse time.
//
// The back button lives in the drawer's fixed header (same row as the X
// close button), NOT inside the scrollable drill panels themselves — so it
// stays visible without scrolling. Each panel carries data-back-target/
// data-back-label attributes; whenever the active panel changes, the header
// back button is updated (or hidden, on the root panel) to match.
(function () {
  function updateHeaderBackButton(drill) {
    var headerBack = document.getElementById('TweMobileNavHeaderBack');
    if (!headerBack) return;

    var activePanel = drill.querySelector('.twe-mobile-nav-panel.is-active');
    var backTarget = activePanel && activePanel.getAttribute('data-back-target');

    if (!backTarget) {
      headerBack.classList.remove('is-visible');
      return;
    }

    var label = headerBack.querySelector('.twe-mobile-nav-header-back__label');
    if (label) label.textContent = activePanel.getAttribute('data-back-label') || '';
    headerBack.setAttribute('data-target', backTarget);
    headerBack.classList.add('is-visible');
  }

  function showPanelInDrill(drill, targetId) {
    drill.querySelectorAll('.twe-mobile-nav-panel').forEach(function (panel) {
      panel.classList.toggle('is-active', panel.getAttribute('data-panel') === targetId);
    });

    var scrollable = drill.closest('.drawer__scrollable');
    if (scrollable) scrollable.scrollTop = 0;

    updateHeaderBackButton(drill);
  }

  document.addEventListener('click', function (e) {
    // Header back button lives outside .twe-mobile-nav-drill (it's in the
    // fixed header), so it can't be resolved via .closest('.twe-mobile-nav-drill').
    var headerBack = e.target.closest('#TweMobileNavHeaderBack');
    if (headerBack) {
      var drill = document.querySelector('.twe-mobile-nav-drill');
      var targetId = headerBack.getAttribute('data-target');
      if (drill && targetId) {
        showPanelInDrill(drill, targetId);
        e.preventDefault();
      }
      return;
    }

    var trigger = e.target.closest('[data-target]');
    if (!trigger) return;
    var drillForTrigger = trigger.closest('.twe-mobile-nav-drill');
    if (!drillForTrigger) return;

    showPanelInDrill(drillForTrigger, trigger.getAttribute('data-target'));
    e.preventDefault();
  });

  // Reset every drill-down menu back to its root panel whenever the drawer
  // is opened (via the hamburger button) or closed (via the X button), so
  // shoppers don't land mid-navigation next time. NOTE: while the drawer is
  // open, <html> itself carries a class of "js-drawer-open" (added by
  // theme.js's Drawers component) — every click bubbles up through <html>,
  // so checking for the generic "js-drawer-open" class here would match on
  // every single click, not just the open button. Match the specific
  // hamburger-button class (js-drawer-open-nav) instead.
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.js-drawer-close') && !e.target.closest('.js-drawer-open-nav')) return;
    document.querySelectorAll('.twe-mobile-nav-drill').forEach(function (drill) {
      showPanelInDrill(drill, 'root');
    });
  });
})();
